import client from 'data/client';
import { CDError } from 'utils/error';

export type PauseVariables = {
  brandId?: string;
  integrationId?: string;
  busyModeType: string;
  customDate: string;
  customTime: string;
};

export type UnPauseVariables = {
  brandId?: string;
  integrationId?: string;
};

export type ResponseStatus = {
  status: string;
};

export const pauseIntegration = async ({
  brandId,
  integrationId,
  busyModeType,
  customDate,
  customTime,
}: PauseVariables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/brands/${brandId || 'all'}/pause`,
      {
        busyModeType,
        integrationId,
        customDate,
        customTime,
        allBrands: brandId == null,
      },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString(), error.response?.data);
  }
};

export const unpauseIntegration = async ({
  brandId,
  integrationId,
}: UnPauseVariables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/brands/${brandId || 'all'}/unpause`,
      {
        integrationId,
        allBrands: brandId == null,
      },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString(), error.response?.data);
  }
};
